export default "__VITE_ASSET__00e55138__"